import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext, useRef, useEffect } from 'react';
import { Icon } from '../../icon/index.js';
import { FCTheme } from '../../../theming/FCTheme.js';
import { MenuItemStyled } from './style.js';
import { DropdownMenuContext } from './DropdownMenuContext.js';

var MenuItem = function MenuItem(_a) {
  var children = _a.children,
      icon = _a.icon,
      index = _a.index,
      _b = _a.onClick,
      _onClick = _b === void 0 ? function () {
    return undefined;
  } : _b,
      rest = __rest(_a, ["children", "icon", "index", "onClick"]);

  var _c = useContext(DropdownMenuContext),
      dispatch = _c.dispatch,
      dropdownState = _c.dropdownState;

  var isMounted = useRef(true);
  var theme = useContext(FCTheme);
  var menuItem = useRef(null);
  useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  return /*#__PURE__*/React.createElement(MenuItemStyled, __assign({
    ref: menuItem,
    id: dropdownState.id + "_menuitem_" + index,
    theme: theme.theme,
    tabIndex: -1,
    "aria-selected": dropdownState.selectedItemIndex === index ? true : false,
    onMouseOver: function onMouseOver() {
      dispatch({
        type: 'SET_SELECTED_ITEM_INDEX',
        payload: index
      });
      dispatch({
        type: 'SET_ACTIVE_DESCENDANT',
        payload: dropdownState.id + "_menuitem_" + index
      });
    },
    onClick: function onClick() {
      dispatch({
        type: 'SET_MENU_OPEN',
        payload: false
      });
      setTimeout(function () {
        dispatch({
          type: 'SET_MENU_VISIBLE',
          payload: false
        });
      }, 200);

      _onClick();
    },
    role: "menuitem"
  }, rest), icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  }), children);
};

export default MenuItem;
export { MenuItem };